import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthService {
    static getAuth(){
        var auth = localStorage.getItem("auth");
        if (auth == null || auth == "null") {
            return null;
        }
        var user = JSON.parse(auth);
        return user.token;
    }
    currentUser: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(private http: HttpClient) {
    }

    isAuthed(): boolean {
        var auth = localStorage.getItem("auth");
        if (auth == null || auth == "null") {
            return false;
        }

        if (this.currentUser.value == null)
            this.currentUser.next(JSON.parse(auth));

        return true;
    }


    authFromMFA(): boolean {
        var auth = localStorage.getItem("mfa");
        if (auth == null || auth == "null") {
            return false;
        }
        localStorage.setItem("auth", auth);

        if (this.currentUser.value == null)
            this.currentUser.next(JSON.parse(auth));

        return true;
    }

    public login(email, password): Promise<any> {
        return new Promise((resolve, reject) => {
            var dto = {
                email: email,
                password: password
            }
            this.http.post<any>(environment.apiUrl + 'account/login', dto).subscribe(data => {
                //console.log(data);
                if (!data.mfa) {
                    localStorage.setItem("auth", JSON.stringify(data));
                    this.currentUser.next(data);
                } else {
                    localStorage.setItem("mfa", JSON.stringify(data));
                    this.currentUser.next(data);
                }
                resolve(data);

            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }

    public confirmMFA(email, password, mfa, id): Promise<any> {
        return new Promise((resolve, reject) => {
            var dto = {
                id: id,
                email: email,
                password: password,
                code: mfa
            }
            this.http.post<any>(environment.apiUrl + 'account/confirmMFA', dto).subscribe(data => {
                localStorage.setItem("auth", JSON.stringify(data));
                this.currentUser.next(data);
                resolve(data);

            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }

    public logout() {
        localStorage.setItem("auth", null);
        localStorage.setItem("mfa", null);
        this.currentUser.next(null);
    }

}
